import React, { FC, useEffect } from 'react';
import { useUser, useTabSync } from './common';
import { Routes } from './logic';

const App: FC = (): JSX.Element => {
	useUser();
	useTabSync();

	useEffect(() => {
		if (process.env.REACT_APP_TEST === 'true') {
			// eslint-disable-next-line no-console
			console.log('REACT_APP_BASE_URL::', process.env.REACT_APP_BASE_URL);
			// eslint-disable-next-line no-console
			console.log('REACT_APP_BOV3_API_URL::', process.env.REACT_APP_BOv3_API_URL);
			// eslint-disable-next-line no-console
			console.log('REACT_APP_ENV::', process.env.REACT_APP_SITE_TITLE);
		}
	}, []);

	return (
		<div className='App'>
			<Routes />
		</div>
	);
};

export default App;
